import { useEffect } from 'react';
import { useFieldValue } from '@qover/hooks';
import { Risk } from '../domain/Risk';

type UpdatePersonCountProps = {
  draftId?: string;
  updateDraft: () => Promise<unknown>;
};
export function UpdatePersonCount(props: UpdatePersonCountProps) {
  const risk = useFieldValue<Risk>('risk');

  useEffect(() => {
    if (props.draftId) {
      props.updateDraft();
    }
  }, [props.draftId, risk.adultsList?.length, risk.childrenList?.length]);

  return null;
}
